<template>
  <b-container class="edit-trainer" fluid>
    <breadcrumb level="trainer"></breadcrumb>
    <div id="trainer">
      <h1 class="title">Edit Trainer</h1>
      <div id="alerts">
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
          >You have successfully edited this trainer!</b-alert
        >
        <b-alert :show="showError" dismissible variant="warning"
          >Something went Wrong. Please refresh and try again.</b-alert
        >
      </div>
      <b-row>
        <b-col>
          <active-input plural="trainers" singular="trainer"></active-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <basic-info singular="trainer" plural="trainers"></basic-info>
        </b-col>
        <b-col>
          <trainer-designation></trainer-designation>
        </b-col>
        <b-col>
          <contact-info singular="trainer" plural="trainers"></contact-info>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <geo-info
            plural="trainers"
            parent="et"
            singular="trainer"
            :coords="false"
          ></geo-info>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <trainer-education></trainer-education>
        </b-col>
      </b-row>
      <br />
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Trainer's Groups" active>
            <div class="trainer-groups">
              <h4 class="sub-title">Trainer's Groups</h4>
              <trainer-groups id="trainer-groups"></trainer-groups>
            </div>
          </b-tab>
          <b-tab title="Trainer's Teachers">
            <div class="trainer-teachers">
              <h4 class="sub-title">Trainer's Teachers</h4>
              <trainer-teachers id="trainer-teachers"></trainer-teachers>
            </div>
          </b-tab>
          <b-tab title="Trainer's Schools">
            <div class="trainer-schools">
              <h4 class="sub-title">Trainer's Schools</h4>
              <trainer-schools id="trainer-schools"></trainer-schools>
            </div>
          </b-tab>
          <b-tab title="Trainer's Classes">
            <div class="trainer-classes">
              <h4 class="sub-title">Trainer's Classes</h4>
              <trainer-classes id="trainer-classes"></trainer-classes>
            </div>
          </b-tab>
          <b-tab title="Trainer's Primary Schools">
            <div class="trainer-primary-schools">
              <h4 class="sub-title">Trainer's Primary Schools</h4>
              <trainer-primary-schools
                id="trainer-primary-schools"
              ></trainer-primary-schools>
            </div>
          </b-tab>
          <b-tab title="Module Observations">
            <div class="observations">
              <h4 class="sub-title">Module Observations</h4>
              <trainer-observation id="modules" type="module"></trainer-observation>
            </div>
          </b-tab>
          <b-tab title="Maintenance Observations">
            <div class="observations">
              <h4 class="sub-title">Maintenance Observations</h4>
              <trainer-observation id="modules" type="maintenance"></trainer-observation>
            </div>
          </b-tab>
          <b-tab title="Covid Observations">
            <div class="covid-observations">
              <h4 class="sub-title">Covid Observations</h4>
              <trainer-covid-observation
                id="covid-obs"
              ></trainer-covid-observation>
            </div>
          </b-tab>
          <b-tab title="Teacher Support Workshops">
            <div class="teacher-support">
              <h4 class="sub-title">Teacher Support Workshops</h4>
              <teacher-support id="teacher-support"></teacher-support>
            </div>
          </b-tab>
          <b-tab title="Standard Module">
            <div class="training-modules">
              <h4 class="sub-title">Standard Module</h4>
              <training-modules id="training-modules" type="module"></training-modules>
            </div>
          </b-tab>
          <b-tab title="Maintenance Module">
            <div class="training-modules">
              <h4 class="sub-title">Maintenance Module</h4>
              <training-modules id="training-modules" type="maintenance"></training-modules>
            </div>
          </b-tab>
          <b-tab title="Data Consent">
            <div class="data-consent">
              <h4 class="sub-title">Data Consent</h4>
              <data-consent id="data-consent" type="trainer"></data-consent>
            </div>
            <div class="data-consent mt-3">
             <data-consent-trainer id="data-consnent-trainer"/>
          </div>
          </b-tab>
        </b-tabs>
      </b-card>
      <confirm-submit v-if="isAdmin"></confirm-submit>
      <b-button
        v-if="isAdmin"
        :size="'lg'"
        :variant="'primary'"
        class="app_trainer_btn mb-4"
        @click.prevent="updateTrainer"
        :disabled="isDisabled"
        >Edit Trainer</b-button
      >
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SchoolService from "@/services/SchoolService";
import BasicInfo from "@/components/BasicInfo";
import TrainerDesignation from "@/components/TrainerDesignation";
import TrainerGroups from "@/components/TrainerGroups";
import TrainerSchools from "@/components/TrainerSchools";
import TrainerPrimarySchools from "@/components/TrainerPrimarySchools";
import TrainerTeachers from "@/components/TrainerTeachers";
import TrainerEducation from "@/components/TrainerEducation";
import TeacherSupport from "@/components/TeacherSupport";
import ConfirmSubmit from "@/components/ConfirmSubmit";
import ContactInfo from "@/components/ContactInfo";
import GeoInfo from "@/components/GeoInfo";
import TrainerObservation from "@/components/TrainerObservation";
import TrainerCovidObservation from "@/components/TrainerCovidObservation";
import TrainingModules from "@/components/TrainingModules";
import ActiveInput from "@/components/ActiveInput";
import Breadcrumb from "@/components/Breadcrumb";
import DataConsent from "@/components/DataConsent";
import DataConsentTrainer from "@/components/DataConsentTrainer";
import TrainerClasses from "@/components/TrainerClasses";

export default {
  name: "EditTrainer",
  components: {
    BasicInfo,
    TrainerDesignation,
    TrainerEducation,
    ContactInfo,
    GeoInfo,
    TrainerObservation,
    TrainerCovidObservation,
    TrainingModules,
    ConfirmSubmit,
    TrainerSchools,
    TrainerPrimarySchools,
    TrainerTeachers,
    TeacherSupport,
    ActiveInput,
    TrainerGroups,
    Breadcrumb,
    DataConsent,
    DataConsentTrainer,
    TrainerClasses
  },
  data() {
    return {
      showSchools: false,
      showError: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      isDisabled: false,
      allSchools: [],
    };
  },
  methods: {
    ...mapActions({
      RESET_TRAINERS_STATE: "trainers/RESET_TRAINERS_STATE",
      GET_TRAINER: "trainers/GET_TRAINER",
      UPDATE_TRAINER: "trainers/UPDATE_TRAINER",
    }),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    flashSuccess() {
      this.dismissCountDown = this.dismissSecs;
    },
    flashError() {
      this.showError = !this.showError;
    },
    async updateTrainer() {
      if (!this.$store.state.confirmed) {
        alert("Please confirm the information above is correct");
        return;
      }
      if (
        this.$store.state.trainers.trainer.first_name.length === 0 ||
        this.$store.state.trainers.trainer.last_name.length === 0 ||
        this.$store.state.trainers.trainer.sex.length === 0
      ) {
        window.scrollTo(0, 0);
        this.flashError();
      } else {
        this.isDisabled = true;
        await this.UPDATE_TRAINER();
        window.scrollTo(0, 0);
        await this.flashSuccess();
        await this.$store.commit("resetConfirmed");
        await this.RESET_TRAINERS_STATE();
        setTimeout(() => {
          this.$router.push("/trainers");
        }, 1500);
      }
    },
    async getSchools() {
      const res = await SchoolService.fetchSchools();
      this.allSchools = res.data;
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
    }),
    trainer: {
      get() {
        return this.$store.state.trainers.trainer;
      },
    },
  },
  created() {
    this.GET_TRAINER(this.$route.params.id);
    this.getSchools();
  },
};
</script>

<style scoped>
#trainer {
  width: 75%;
  white-space: nowrap;
  margin: 0 auto;
  text-align: center;
}
.form div {
  margin: 20px;
}
.app_trainer_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
.assigned-schools {
  list-style-type: none;
  display: inline;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}

div#assigned-schools,
#obs {
  float: left;
  padding: 1%;
}
</style>
